<template>
  <section class="quote" v-if="show" :class="{'quote-fullbleed': fullbleed}">
    <div class="quote-image">
      <img v-if="item.image" :src="item.image" alt="">
    </div>
    <div class="quote-body">
      <blockquote>
        <icon-quote :fill="iconfill" />
        <p>{{ item.quote }}</p>
        <footer>
          <span class="name">{{ item.author }}</span>
          <span class="position" v-if="item.position">{{ item.position }}</span>
        </footer>
      </blockquote>

      <!-- <div class="media" v-if="item.media">
        <img :src="item.media" alt="">
      </div> -->

    </div>
  </section>
</template>

<script>
import AbstractSection from './abstract'
import iconQuote from '@icons/icon-quote'

export default AbstractSection.extend({
  components: { iconQuote },
  props: {
    iconfill: {
      default: '#E4003F',
      required: false,
      type: String
    }
  },
  computed: {
    fullbleed () {
      return this.item.layout !== 'Opdelt'
    },
    show () {
      return this.fullbleed ? true : this.item.image
    }
  }
})
</script>

<style lang="scss">
/* Import from Spar Nord Assets */
@import '~@styles/global/index';
@import '~@styles/colors/variables';
@import '~@styles/mq/variables';
@import '~@styles/mixins/index';
@import '~@animations/easings/variables';
@import '~@animations/durations/variables';

@import '~@helpers/grid';
@import '~@helpers/no-drag';

.quote {
  position: relative;
}

.quote-image img {
  @include object-fit(cover, center);

  @extend .no-drag;
}

.quote-body {
  padding: $global-padding 0;

  @media #{$above-breakpoint-768} {
    padding: $global-padding calc(#{$global-padding} * 4);
  }
}

blockquote {
  text-align: center;

  .icon-quote {
    margin-bottom: $global-padding;
  }

  p {
    @include font-size (20px, 31px);
    line-height: 1.2;
    font-weight: bold;

    margin-bottom: $global-padding;
  }

  span {
    @include font-size(16px, 20px);
    font-weight: bold;
    display: block;

    &.name {
      margin-bottom: $global-padding / 4;
    }
  }

  @media #{$above-breakpoint-768} {
    p {
      margin-bottom: $global-padding * 2;
    }
  }
}

.quote .media {
  margin-top: $global-padding * 2;

  img {
    max-width: 100%;
    height: auto;
  }
}

/* NOT FULLBLEED */
.quote:not(.quote-fullbleed) {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: space-between;
  align-items: center;

  &:nth-of-type(even) {
    @media #{$above-breakpoint-768} {
      .quote-body {
        order: 1
      }

      .quote-image {
        order: 2;
      }
    }
  }

  @include container($global-width, 100%, $global-padding);

  .quote-image, .quote-body {
    flex: 0 0 100%;
  }

  .quote-image {
    @include aspect-ratio(4, 5);
    max-height: 630px;

    img {
      @include object-fit(cover, center);
    }
  }

  blockquote {
    span.name {
      color: $color-red;
    }
    span.position {
      color: $color-grey-xx;
    }
  }

  @media #{$above-breakpoint-768} {
    .quote-image, .quote-body {
      flex: 0 0 50%;

      @at-root .internet-explorer #{&} {
        flex: 0 0 40%;
      }
    }

    .quote-body {
      padding: $global-padding;
    }
  }
}

/* FULLBLEED QUOTE */
.quote-fullbleed {
  min-height: 700px;

  display: flex;
  align-items: stretch;

  .quote-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $color-black;

    @media #{$below-breakpoint-768} {
      img {
        opacity: .3;
      }
    }

    img {
      @include object-fit(cover, 75%);
    }

    @media #{$above-breakpoint-768} {
      img {
        @include object-fit(cover, center);
      }
    }
  }

  .quote-body {
    position: absolute;
    z-index: 1;
    top: 50%;
    transform: translateY(-50%);

    display: flex;

    padding: $global-padding;

    height: 100%;
    max-width: 100%;
    width: $global-width;

    blockquote {
      align-self: center;
    }

    @media #{$above-breakpoint-768} {
      padding: 0;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);

      blockquote {
        @include item-size(20);
        @include item-offset(3);
      }
    }
  }

  blockquote {
    text-align: center;

    p {
      color: $color-gold;
    }

    span {
      &.name {
        color: $color-red;
      }

      &.position {
        color: $color-gold;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/quote.vue